// extracted by mini-css-extract-plugin
export default {"path":"Share_path__kp7W0","heading":"Share_heading__p05-P","label":"Share_label__g8wry","copy_container":"Share_copy_container__6tlLh"};